(function ($) {
  $(function () {
    let currentPage = 1;

    function loadResources() {
      let $button = $("#showMoreInsightsButton"),
        $posts = $("#posts"),
        data = {
          action: "load_news_insights",
          query: news_insights_params.posts,
          currentPage: currentPage,
          catFilter: news_insights_params.catFilter,
          discrete: news_insights_params.discrete,
        };
      $.ajax({
        url: news_insights_params.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function () {
          $button.text("Loading More News & Insights...");
          $("#loadingView").fadeIn();
        },
        success: function (data) {
          if (data) {
            $posts.append(data);
            if ($(".newsInsightsItemEnd").length) {
              $button.addClass("disabled");
              $button.attr("disabled", "disabled");
              $button.text("No More News & Insights to Share");
            } else {
              $button.removeClass("disabled");
              $button.removeAttr("disabled");
              $button.text("Load More News & Insights");
            }
            $(
              ".c-news-component.c-news-block, .newsInsightsItemEnd",
              $posts
            ).each(function (index) {
              const row = $(this);
              setTimeout(function () {
                row.addClass("show");
              }, 50 * index);
            });
          }
          $("#loadingView").fadeOut();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        },
      });
    }

    function updatePushState(cat_filter) {
      if (window.history.pushState) {
        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname;

        if (cat_filter) {
          newurl += "?cat=" + cat_filter;
        }

        window.history.pushState({ path: newurl, cat: cat_filter }, "", newurl);
      }
    }

    function filterCatHandler() {
      let $button = $("#news-cat-filter"),
        topicName = $button.val();

      $("#posts").empty();
      $("#showMoreInsightsButton")
        .removeClass("disabled")
        .removeAttr("disabled");
      currentPage = 1;
      news_insights_params.catFilter = topicName;

      updatePushState(news_insights_params.catFilter);
      loadResources();
    }

    function loadMoreResourcesHandler() {
      currentPage++;
      updatePushState(news_insights_params.catFilter);
      loadResources();
    }

    function initialLoadResources() {
      currentPage = 1;
      $("#posts").empty();
      $("#news-cat-filter").val(news_insights_params.catFilter);
      loadResources();
    }
    window.history.replaceState(
      {
        path: window.location.href,
        cat: news_insights_params.catFilter,
      },
      ""
    );

    $(window).on("popstate", function (e) {
      if (e.originalEvent.state) {
        news_insights_params.catFilter = e.originalEvent.state.cat || "";
      }
      initialLoadResources();
    });
    $("#news-cat-filter").on("change", filterCatHandler);
    $("#showMoreInsightsButton").on("click tap", loadMoreResourcesHandler);
    initialLoadResources();
  });
})(jQuery);
